import styled from "styled-components";

import { SimpleUserInitialsNameContainer } from "shared/components/atoms/SimpleUserInitials/styles";
import { SimpleUserPhotoContainer } from "shared/components/atoms/SimpleUserPhoto/styles";

export const OnlineRecentlyContainer = styled.div`
  margin: 2rem 0;

  .title {
    font: 500 0.875rem/1.3125rem "Inter";
    color: ${({ theme }) => theme.feed.usernameColor};

    margin-bottom: 12px;
  }

  ul {
    margin: 0;

    display: flex;
    gap: 12px;

    overflow-x: scroll;
    max-width: calc(100vw - 2rem);

    &::-webkit-scrollbar {
      height: 4px;
      display: none;
    }

    &::-webkit-scrollbar-track {
      height: 4px;
      display: none;
    }

    &::-webkit-scrollbar-thumb {
      height: 4px;
      display: none;
    }

    li {
      list-style: none;

      position: relative;

      .online-dot {
        width: 12px;
        height: 12px;
        background: #3ed455;
        border-radius: 50%;
        box-shadow: 0px 0px 3px 4px #3ed45540;
        position: absolute;
        top: 7px;
        right: 1px;
      }
    }
  }

  ${SimpleUserPhotoContainer} {
    ${SimpleUserInitialsNameContainer},&,
    img {
      width: 65px !important;
      height: 65px !important;
    }
  }
`;
